import { render } from "./InputSwitchButton.vue?vue&type=template&id=bda0a1a8&scoped=true"
import script from "./InputSwitchButton.vue?vue&type=script&lang=js"
export * from "./InputSwitchButton.vue?vue&type=script&lang=js"

import "./InputSwitchButton.vue?vue&type=style&index=0&id=bda0a1a8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bda0a1a8"]])

export default __exports__